import type { SafheNetConfig } from './types'
import * as analytics from '../analytics'
import { copy } from '../clipboard'
import { share } from '../sharing'
import * as theme from '../theme'
import { openDialog } from '../ui/dialog'
import { openModal } from '../ui/modal'
import { toast } from '../ui/toast'
import { attachTooltip } from '../ui/tooltip'
import * as device from '../utils/device'
import { configureIconBase, icon, iconInline } from '../utils/icon'
import * as storage from '../utils/storage'
import * as url from '../utils/url'
import { detectDirection } from './direction'

const VERSION = '1.0.0'

function resolveConfig(): SafheNetConfig {
  const provided = window.SafheNetConfig ?? {}
  // Derive base path from this script's own <script src>, falling back
  // to /shared/v1, so pages don't have to declare it manually.
  const currentScript = document.currentScript as HTMLScriptElement | null
  const inferredBase = currentScript?.src
    ? new URL('.', currentScript.src).pathname.replace(/\/js\/?$/, '')
    : '/shared/v1'

  return {
    base: provided.base ?? inferredBase,
    dir: provided.dir,
    analyticsEndpoint: provided.analyticsEndpoint,
  }
}

function init(): void {
  const config = resolveConfig()
  const dir = detectDirection(config.dir)

  configureIconBase(config.base)
  analytics.init(config.analyticsEndpoint)
  theme.init()

  window.SafheNet = {
    version: VERSION,
    config,
    dir,
    copy,
    share,
    icon,
    iconInline,
    analytics,
    ui: { modal: openModal, toast, tooltip: attachTooltip, dialog: openDialog },
    device,
    storage,
    url,
    theme: {
      get: theme.getResolved,
      getPreference: theme.getPreference,
      set: theme.setTheme,
      toggle: theme.toggle,
      onChange: theme.onChange,
    },
  }

  analytics.pageview()
}

init()
